import React from 'react';
import PropTypes from 'prop-types';

export default function inScrollContext(Comp) {
  const InScrollContext = (props, context) => {
    return <Comp {...{ ...props, scroll: context.scroll }} />;
  };

  InScrollContext.displayName = Comp.displayName || Comp.name;

  InScrollContext.contextTypes = {
    scroll: PropTypes.bool,
  };

  return InScrollContext;
}
